import styled from "styled-components";

export const Radio = styled.span`
    flex-shrink: 0;
    width: var(--checkbox-width);
    height: var(--checkbox-height);

    border: 1px solid var(--checkbox-border-color);
    background-color: var(--checkbox-background-color);
    border-radius: 50%;
    margin: var(--checkbox-margin);

    transition: 0.3s;

    position: relative;

    input:focus ~ & {
        box-shadow: 0 0 0 4px var(--checkbox-ring-color);
    }

    ::before {
        content: "";

        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        width: calc(var(--checkbox-check-size) / 2);
        height: calc(var(--checkbox-check-size) / 2);

        border-radius: 50%;
        background-color: var(--checkbox-check-color);
    }
`;
